import { apiUrl } from '../../../settings'

export const listAllReviewerURL = () => {
  return apiUrl + '/reviewer'
}
export const singleReviewerURL = id => {
  return apiUrl + `/reviewer/${id}`
}
